import { appApi } from './app_api';

export const customerApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomer: builder.query({
      query: ({ customerId, orgUrl }) => `${orgUrl ? `${orgUrl}` : `customers/${customerId}`}`,
      transformResponse: (response) => response.customer,
      providesTags: (result, error, { customerId }) => [
        { type: 'Customer', id: customerId },
      ],
    }),
    getLeaderboard: builder.query({
      query: (customerId) => `/customers/${customerId}/leaderboard`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, customerId) => [{ type: 'Leaderboard', id: customerId }],
    }),
    getDivisionLeaderboard: builder.query({
      query: ({ customerId, divisionId }) => `/customers/${customerId}/leaderboard?division_id=${divisionId}`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, { customerId, divisionId }) => [{ type: 'Leaderboard', id: `${customerId}-${divisionId}` }],
    }),
    getCanPublicEvents: builder.query({
      query: (customerId) => `/customers/${customerId}/can_public_events`,
      transformResponse: (response) => response.data,
    }),
    presignDescriptionImage: builder.mutation({
      query: ({ customerId, fileName, contentType, byteSize }) => ({
        url: `/customers/${customerId}/presign_description_image`,
        method: 'POST',
        body: {
          file_name: fileName,
          content_type: contentType,
          byte_size: byteSize,
        },
      }),
      transformResponse: (response) => response.data,
    }),
    uploadDescriptionImageToPresignedUrl: builder.mutation({
      async queryFn({ uploadUrl, headers, file }) {
        try {
          const response = await fetch(uploadUrl, {
            method: 'PUT',
            headers: headers || { 'Content-Type': file.type },
            body: file,
          });

          if (!response.ok) {
            return {
              error: {
                status: response.status,
                data: 'Upload failed',
              },
            };
          }

          return { data: { success: true } };
        } catch (error) {
          return {
            error: {
              status: 'FETCH_ERROR',
              data: error?.message || 'Upload failed',
            },
          };
        }
      },
    }),
    editCustomer: builder.mutation({
      query: ({ customerId, name, address, description }) => ({
        url: `/customers/${customerId}`,
        method: 'PUT',
        body: { name, address, description },
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Customer', id: customerId }],
    }),
    requestCustomerAccount: builder.mutation({
      query: (request) => ({
        url: `/customers/request_account`,
        method: 'POST',
        body: request,
      }),
    }),
    addCustomer: builder.mutation({
      query: ({ customer, phone }) => ({
        url: `/customers`,
        method: 'POST',
        body: { customer, phone },
      }),
      invalidatesTags: [{ type: 'Customers', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetCustomerQuery,
  useGetLeaderboardQuery,
  useGetDivisionLeaderboardQuery,
  useGetCanPublicEventsQuery,
  usePresignDescriptionImageMutation,
  useUploadDescriptionImageToPresignedUrlMutation,
  useEditCustomerMutation,
  useRequestCustomerAccountMutation,
  useAddCustomerMutation,
} = customerApi;
